import Children from "pages/Children";
import Finance from "pages/Finance";
import Gallery from "pages/Gallery";
import Profile from "pages/Profile";
import Reports from "pages/Reports";
import Settings from "pages/Settings";
import Timeline from "pages/Timeline";
import Transactions from "pages/Transactions";
import Login from "../pages/Login";
import Parents from "pages/Parents";
import AddParent from "pages/AddParent";
import EditParent from "pages/EditParent";
import AddChild from "pages/AddChild";
import EditChild from "pages/EditChild";
import { Navigate } from "react-router-dom";
import ChildrenManage from "pages/ChildrenManage";
import Nursery from "pages/Nursery";
import AddStaff from "pages/AddStaff";
import EditStaff from "pages/EditStaff";
import Classrooms from "pages/Classrooms";
import Newsletter from "pages/Newsletter";
import ViewNewsletter from "pages/ViewNewsletter";
import Attendance from "pages/Attendance";
import Grading from "pages/Grading";
import ChildDevelopment from "pages/ChildDevelopment";
import Menu from "pages/Menu";

export interface RouteConfig {
  path: string;
  element: JSX.Element;
  settings?: any;
  auth?: boolean;
  label?: string;
  role?: string[];
}

const onlyMain = {
  sidebar: false,
  toolbar: false,
  footer: false,
};

const routesConfig: RouteConfig[] = [
  {
    path: "/",
    element: <Navigate to="/timeline" />,
  },
  {
    path: "/login",
    element: <Login />,
    settings: {
      layout: onlyMain,
    },
    auth: false,
  },
  {
    path: "/profile",
    element: <Profile />,
    label: "profile",
    role: ["PARENT", "NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
  },
  {
    path: "/timeline",
    element: <Timeline />,
    label: "timeline",
    role: ["PARENT", "NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
  },
  {
    path: "/children",
    element: <Children />,
    label: "children",
    role: ["PARENT"],
  },
  {
    path: "/finance/transactions",
    element: <Transactions />,
    label: "posts.transactions",
    role: ["PARENT", "NURSERY_ADMIN"],
  },
  {
    path: "/reports",
    element: <Reports />,
    label: "report",
    role: ["PARENT", "NURSERY_ADMIN"],
  },
  {
    path: "/finance",
    element: <Finance />,
    label: "finance",
    role: ["PARENT", "NURSERY_ADMIN"],
  },
  {
    path: "/settings",
    element: <Settings />,
    label: "setting",
    role: ["PARENT", "NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
  },
  {
    path: "/gallery",
    element: <Gallery />,
    label: "gallery",
    role: ["PARENT", "NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
  },
  {
    path: "/parents",
    element: <Parents />,
    label: "parents",
    role: ["NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
  },
  {
    path: "/parents/add",
    element: <AddParent />,
    label: "parents",
    role: ["NURSERY_ADMIN"],
  },
  {
    path: "/parents/edit",
    element: <EditParent />,
    label: "parents",
    role: ["NURSERY_ADMIN"],
  },
  {
    path: "/child",
    element: <ChildrenManage />,
    label: "child",
    role: ["NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
  },
  {
    path: "/child/add",
    element: <AddChild />,
    label: "child",
    role: ["NURSERY_ADMIN"],
  },
  {
    path: "/child/edit",
    element: <EditChild />,
    label: "child",
    role: ["NURSERY_ADMIN"],
  },
  {
    path: "/child/:childId/development",
    element: <ChildDevelopment />,
    label: "child",
    role: ["NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
  },
  {
    path: "/nursery",
    element: <Nursery />,
    label: "staff",
    role: ["NURSERY_ADMIN"],
  },
  {
    path: "/nursery/add",
    element: <AddStaff />,
    label: "staff",
    role: ["NURSERY_ADMIN"],
  },
  {
    path: "/nursery/edit",
    element: <EditStaff />,
    label: "staff",
    role: ["NURSERY_ADMIN"],
  },
  {
    path: "/class",
    element: <Classrooms />,
    label: "classroom",
    role: ["NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
  },
  {
    path: "/newsletter",
    element: <Newsletter />,
    label: "newsletter",
    role: ["PARENT", "NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
  },
  {
    path: "/newsletter/view",
    element: <ViewNewsletter />,
    label: "newsletter",
    role: ["PARENT", "NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
  },
  {
    path: "/grading",
    element: <Grading />,
    label: "grading",
    role: ["NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
  },
  {
    path: "/attendance",
    element: <Attendance />,
    label: "attendance",
    role: ["PARENT", "NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
  },
  {
    path: "/menu",
    element: <Menu />,
    label: "menu",
    role: ["PARENT", "NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
  },
  {
    path: "*",
    element: <Navigate to="/timeline" replace />,
    role: ["PARENT", "NURSERY_ADMIN", "ROOM_LEADER", "NURSERY_PRACTITIONER"],
  },
];

export default routesConfig;
